import React, { useState, useEffect } from "react"; 
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material"; 
import { useSaveDefaultPage } from "../../hooks/useSaveDefaultPage";


export function getRouteMap({ businessUrl, staffUrl }) {
  const baseStaffPath = `/${businessUrl}/${staffUrl}`;
  return { 
    2: `/biz/bookingtypes`, // Booking type page
    3: `/biz/calendar`,               // Calendar
    4: `${baseStaffPath}/wallet`,                 // Wallet
  };
}

// Centralized page options for dropdown labels
export const pageOptions = [ 
  { id: 2, label: "Booking Type Page" },
  { id: 3, label: "Calendar" },
  { id: 4, label: "Wallet" },
];

/**
 * Reusable dialog component to select and save default page
 * Props:
 * - open    : boolean
 * - value   : number             // current defaultPageId
 * - onClose : () => void
 * - onSaved : (newPageId: number) => void  // parent callback
 */
const DefaultPageDialog = ({ open, value, onClose, onSaved }) => {
  const [selectedPageId, setSelectedPageId] = useState(value || 2); 
  const saveDefaultPage = useSaveDefaultPage();

  useEffect(() => {
    setSelectedPageId(value);
  }, [value]);

  const handleChange = (e) => {
    setSelectedPageId(parseInt(e.target.value, 10));
  };

  const handleSave = async () => {
    try {
      await saveDefaultPage(selectedPageId);
      onSaved(selectedPageId);
    } catch (err) {
      console.error(err);
    } finally {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Select Default Page</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="dense">
          <InputLabel id="default-page-dialog-label">Default Page</InputLabel>
          <Select
            labelId="default-page-dialog-label"
            value={String(selectedPageId)}
            label="Default Page"
            onChange={handleChange}
          >
            {pageOptions.map((opt) => (
              <MenuItem key={opt.id} value={String(opt.id)}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions> 
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DefaultPageDialog;
